/**
 * Distinguishable palette for chart series on dark backgrounds.
 * Ordered for maximum contrast between adjacent items in a stacked bar.
 */
export const SERIES_PALETTE = [
  '#e85d75', // rose
  '#5b9ef5', // blue
  '#f5a623', // amber
  '#6dd49e', // green
  '#c084fc', // purple
  '#f472b6', // pink
  '#38bdf8', // sky
  '#facc15', // yellow
  '#fb923c', // orange
  '#a3e635', // lime
  '#22d3ee', // cyan
  '#c4b5fd', // violet
] as const

export const OTHER_COLOR = '#525252'

/** Pick a palette color for a breakdown entry by its position in the sorted list. */
export function colorForEntry(_entry: unknown, paletteIndex: number): string {
  return SERIES_PALETTE[paletteIndex % SERIES_PALETTE.length]
}
